var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "poetstool - card view",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.738,
    height: 19.738,
    viewBox: "0 0 19.738 19.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 116",
    d: "M3.29 0h2.467a3.29 3.29 0 0 1 3.29 3.29v2.467a3.29 3.29 0 0 1-3.29 3.29H3.29A3.29 3.29 0 0 1 0 5.757V3.29A3.29 3.29 0 0 1 3.29 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 117",
    d: "M13.982 0h2.467a3.29 3.29 0 0 1 3.29 3.29v2.467a3.29 3.29 0 0 1-3.29 3.29h-2.467a3.29 3.29 0 0 1-3.29-3.29V3.29A3.29 3.29 0 0 1 13.982 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 118",
    d: "M3.29 10.692h2.467a3.29 3.29 0 0 1 3.29 3.29v2.467a3.29 3.29 0 0 1-3.29 3.29H3.29A3.29 3.29 0 0 1 0 16.449v-2.467a3.29 3.29 0 0 1 3.29-3.29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 119",
    d: "M13.982 10.692h2.467a3.29 3.29 0 0 1 3.29 3.29v2.467a3.29 3.29 0 0 1-3.29 3.29h-2.467a3.29 3.29 0 0 1-3.29-3.29v-2.467a3.29 3.29 0 0 1 3.29-3.29z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardView);
export default __webpack_public_path__ + "static/media/card-view.43a4761299a9fdca6b60a5b0b9169914.svg";
export { ForwardRef as ReactComponent };